import { IconWarning } from '@/assets/icons/IconWarning';
import { Button } from '@/components';
import React, { JSX, ReactNode, useEffect, useState } from 'react';
import exemploFatura from '../../../../../assets/images/exemploFatura.jpg';

interface Props {
  onClose: () => void;
}

export const ModalAlertAddCredCard: React.FC<Props> = ({ onClose }): JSX.Element => {
  const [timer, setTimer] = useState(10);
  const [buttonEnabled, setButtonEnabled] = useState(false);
  const [currentScreen, setCurrentScreen] = useState<number>(1);

  const renderApproved = (screenNumber: number, goToNextScreen: () => void): React.ReactNode => {
    const renderScreen = (): ReactNode => {
      switch (screenNumber) {
        case 1:
          return (
            <div>
              <div>
                <p className="font-dmsans font-normal text-neutro-w-600 mb-[10px] text-[20px] sm:text-[20px]">
                  <b className="font-dmsans text-red-500">
                    {' '}
                    Você precisará ter acesso à sua fatura do cartão.{' '}
                  </b>
                </p>
                <p className="font-dmsans font-normal text-neutro-w-600 mb-[10px] text-[20px] sm:text-[20px]">
                  <b className="font-dmsans text-red-500">
                    Essa cobrança de até R$ 5,00 é
                    <strong style={{ fontWeight: 'bold' }}> **temporária**</strong> e serve apenas
                    para validar seu cartão.
                  </b>
                </p>
                <p className="font-dmsans font-normal text-neutro-w-600 mb-[10px] text-[18px] sm:text-[20px]">
                  <b className="font-dmsans text-neutro-b-500">
                    A cobrança será automaticamente estornada e<br />
                    **não é a compra final**.
                  </b>
                </p>
                <p className="font-dmsans font-normal text-neutro-w-600 mb-[10px] text-[18px] sm:text-[18px] italic">
                  (Leia tudo com calma)
                </p>
              </div>

              <div className={`mt-[50px]`}>
                <Button
                  type="button"
                  title={buttonEnabled ? 'Próximo' : `Aguarde ${timer}s...`}
                  buttonStyle="primary"
                  size="lg"
                  disabled={!buttonEnabled}
                  className="w-full mb-[25px]"
                  onClick={goToNextScreen}
                />
              </div>
            </div>
          );
        case 2:
          return (
            <div>
              <div>
                <h4 className="font-dmsans text-neutro-b-500 mb-[5px] text-[19px] sm:text-[25px]">
                  Acesse a fatura do seu cartão e procure por:{' '}
                  <b className="font-dmsans text-red-500">Pag*Bancadoingresso R$ XX,xx. </b>
                </h4>
                <div>
                  <p className="font-dmsans font-normal text-neutro-w-600 mb-[5px] text-[20px] sm:text-[20px]">
                    <small className="font-dmsans text-neutro-b-500">Imagem inlustrativa.</small>
                  </p>
                  {/* <p className="font-dmsans font-normal text-neutro-w-600 mb-[5px] text-[20px] sm:text-[20px]">
                        <small className="font-dmsans text-neutro-b-500">
                          Esse valor pode variar e conter centavos.
                        </small>
                      </p> */}
                </div>
                <div className="flex justify-center items-center">
                  <img
                    src={exemploFatura}
                    alt="Exemplo de Fatura"
                    className="max-w-full w-[400px] h-auto"
                  />
                </div>
                <p className="font-dmsans  font-normal text-neutro-w-600 mb-[5px] text-[18px] sm:text-[20px]">
                  <b className="font-dmsans text-neutro-b-500">
                    Grave esse valor cobrado para o proximo passo .
                  </b>
                </p>
              </div>
              <div className={`mt-[20px]`}>
                <Button
                  type="button"
                  title="Fechar"
                  buttonStyle="primary"
                  size="lg"
                  className="w-full mb-[25px]"
                  onClick={onClose}
                />
              </div>
            </div>
          );
        default:
          return null;
      }
    };

    return renderScreen();
  };

  const goToNextScreen = (): void => {
    setCurrentScreen(currentScreen + 1);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          setButtonEnabled(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="w-full mx-auto text-center">
        <div className="flex flex-col justify-center">
          <IconWarning height="50px" className="self-center text-[red] mb-[15px]" />
          <h4 className="font-dmsans font-bold text-neutro-b-400 text-[28px] mb-[15px]">
            Validação do cartão
          </h4>
          <React.Fragment>{renderApproved(currentScreen, goToNextScreen)}</React.Fragment>
        </div>
      </div>
    </>
  );
};
